<template>
  <div class="notification">
    EMot特急パスポート引換券は利用期間外、またはすでに本日分が利用済みです
  </div>
</template>

<script>
export default {
  name: "MFITTCouponNotification",
};
</script>

<style lang="scss">
.notification {
  background-color: #faeeaf;
  border-radius: 10px;
  display: block;
  font-size: 14px;
  margin: 13% 9%;
  padding: 20px;
  text-align: center;
  width: auto;
}
</style>
